import $ from 'jquery';

const $pubsub = $({});

['on', 'one', 'off', 'trigger'].forEach(method => {
    $[method] = $pubsub[method].bind($pubsub)
});
